import dashboardWidget from './dashboardWidget'

export default class dashboardWidgetAgeGroups extends dashboardWidget {

}
